import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { INSIGHTS } from "@/data/insights";

export const Route = createFileRoute("/_app/insights/$articleSlug")({
  head: ({ params }) => {
    const article = INSIGHTS.find((a) => a.slug === params.articleSlug);
    if (!article) {
      return buildHead({
        title: "Insight not found | LohaLink",
        description:
          "This LohaLink market insight is unavailable. Browse our latest scrap metal and steel market analysis.",
        canonical: `/insights/${params.articleSlug}`,
        noindex: true,
      });
    }
    return buildHead({
      title: `${article.title} | LohaLink Insights`,
      description: article.excerpt,
      canonical: `/insights/${article.slug}`,
      ogType: "article",
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Article",
          headline: article.title,
          description: article.excerpt,
          datePublished: article.date,
          author: { "@type": "Organization", name: "LohaLink" },
          publisher: { "@type": "Organization", name: "LohaLink" },
        },
      ],
    });
  },
  component: lazyRouteComponent(() => import("@/pages/InsightArticle")),
});
